if (!customElements.get('dc-product-tabs')) {
  customElements.define('dc-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-tab-source]');
      if (!source) return;
      const groups = {
        specifications: /^(technical |product )?specifications?$/i,
        features: /^(key |product )?features$/i,
        warranty: /^warranty( information)?$/i,
        questions: /^(common questions|frequently asked questions|faqs?)$/i,
        dimensions: /^dimensions$/i,
        included: /^(what.s included|included in the box)$/i
      };
      const boundaries = [...source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div')].flatMap(node => {
        const label = node.textContent.trim().replace(/:$/, '');
        if (label.length > 40 || node.querySelector('h1,h2,h3,h4,h5,h6,p,div')) return [];
        const key = Object.keys(groups).find(key => groups[key].test(label));
        return key ? [{node, key}] : [];
      });
      const sections = [{key: 'overview', node: null}, ...boundaries];
      const panels = [];
      sections.forEach((section, index) => {
        const range = document.createRange();
        if (section.node) range.setStartAfter(section.node);
        else range.setStart(source, 0);
        const next = sections[index + 1];
        if (next) range.setEndBefore(next.node);
        else range.setEnd(source, source.childNodes.length);
        const content = range.cloneContents();
        if (!content.textContent.trim() && !content.querySelector('img,video,iframe,table')) return;
        let entry = panels.find(item => item.key === section.key);
        if (!entry) {
          entry = {key: section.key, content: document.createDocumentFragment()};
          panels.push(entry);
        }
        entry.content.append(content);
      });
      if (!panels.length) return;
      const nav = document.createElement('div');
      nav.className = 'dc-details-tabs';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', this.dataset.label);
      const body = document.createElement('div');
      const buttons = [];
      const activate = (index, focus = false) => {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          body.children[i].hidden = i !== index;
        });
        if (focus) buttons[index].focus();
      };
      panels.forEach((entry, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${this.id}-tab-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', `${this.id}-panel-${index}`);
        button.textContent = this.dataset[entry.key];
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % panels.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + panels.length) % panels.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = panels.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          activate(target, true);
        });
        buttons.push(button);
        nav.append(button);
        const panel = document.createElement('div');
        panel.id = `${this.id}-panel-${index}`;
        panel.className = 'dc-details-panel product-content-below-gallery__description prose';
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        panel.append(entry.content);
        body.append(panel);
      });
      activate(0);
      source.replaceWith(nav, body);
      this.dataset.ready = 'true';
    }
  });
}
